export const DOWNLOAD_FILE_S3_WRAP = "DOWNLOAD_FILE_S3_WRAP"

// MULTIPLES
export const POST_MULTIPLES_FILES = "POST_MULTIPLES_FILES"
export const DELETE_MULTIPLES_FILES = "DELETE_MULTIPLES_FILES"
